export default __webpack_public_path__ + "static/media/cart.ccde433c.svg";